import questionRoutes from './question';
import userRoutes from './user';
import postRoutes from './post';
import appRoutes from './app';
import packRoutes from './pack';
import userAnswerRoutes from './userAnswer';
import contactRoutes from './contact';
import marketPlace from './marketplace';


export default [
  ...questionRoutes,
  ...userRoutes,
  ...postRoutes,
  ...appRoutes,
  ...packRoutes,
  ...userAnswerRoutes,
  ...contactRoutes,
  ...marketPlace
];



// WEBPACK FOOTER //
// ./src/routes/routes.js